
if ($('.id--17').length) {
    if (getShoptetDataLayer('customer').registered) {

    }
    else {
        $('label[for="login"]').closest('.form-group').hide();
        $(".co-contact-information").before(`
            <div class="customLoginWrap">
                <div class="customLogin">
                    <p><strong>${translation('zakaznickyUcet')}</strong> ${translation('prihlasteSe')}</p>
                    <span class="customLoginButton btn btn-secondary">${translation('prihlasitSe')}</span>
                </div>
                
                <div class="customLoginForm">
                    ${$('.user-action #customerLogin').html()}
                </div>
            </div>
        `);
        $('.customLoginWrap .customLoginForm').hide();
    }
    $('html').on('click', '.customLoginButton', function () {
        $(this).toggleClass('openLogin')
        $('.customLoginWrap .customLoginForm').slideToggle();
    });
    $('.customLoginWrap #formLoginIncluded input[name="email"]').attr('placeholder', '').before('<label for="email">' + translation('emailLogin') + '<span>*</span></label>')
    $('.customLoginWrap #formLoginIncluded input[name="password"]').attr('placeholder', '').before('<label for="password">' + translation('hesloLogin') + '<span>*</span></label>')
    $('.customLoginWrap #formLoginIncluded .form-group').not('.social-login-buttons .form-group').wrapAll('<div class="formGroupsWrap"></div>');
    $('.co-contact-information .form-group:first div a ').text(translation('prihlasitSe'));
    $('.customLoginWrap #formLoginIncluded .form-group input').prop('required', false).removeClass('js-validate js-validate-required error-field');
    $('.customLoginWrap #formLoginIncluded .form-control-wrapper .input-wrapper').removeClass('js-validated-element-wrapper')
    $('.customLoginWrap #formLoginIncluded .form-group label span').remove();

    $('html').on('click', '#submit-order.next-step-finish', function () {
        var mhall = {
            email: $('input#email').val(),
            phone: $('input#phone').val(),
            name: $('input#billFullName').val().split(' ')[0],
            surname: $('input#billFullName').val().split(' ')[1] || '',
            street: $('input#billStreet').val(),
            city: $('input#billCity').val(),
            zip: $('input#billZip').val(),
            country: $('select#billCountryId option:selected').text().trim()
        };


        var mhArr = JSON.parse(sessionStorage.getItem("get_info")) || [];

        mhArr = mhArr.filter(item => item.email !== mhall.email);

        mhArr.unshift(mhall);

        sessionStorage.setItem("get_info", JSON.stringify(mhArr));
    });

}




if ($('.id--16, .id--17').length) {
    $('.cart-inner').prepend($('.cart-header'));
    $('#checkoutContent').append($('.next-step .next-step-back').clone());
    $('#checkoutSidebar').append($('.next-step .next-step-back').clone());
}
if ($('.id--16').length) {

    $('#orderFormButton span').text(translation('continueInOrder'));

}
if ($('.id--9').length) {
    if ($('.cart-empty').length) {
        $('.cart-heading').after('<div class="text-center"><a href="/" class="btn btn-primary">' + translation('zpetdoobchodu') + '</a></div>')
    }
    document.addEventListener('ShoptetDOMContentLoaded', function () {
        if ($('.cart-empty').length) {
            $('.cart-heading').after('<div class="text-center"><a href="/" class="btn btn-primary">' + translation('zpetdoobchodu') + '</a></div>')
        }
    });


    function renderUpsells(items, targetSku) {
        const $targetRow = $(
            `.cart-table tbody tr.removeable[data-micro-sku="${targetSku}"]`
        );

        if (!$targetRow.length) return;

        // pojistka – ať se nerenderuje víckrát
        if ($targetRow.next().hasClass('cart-upsell-row')) {
            return;
        }

        let html = `
        <tr class="cart-upsell-row">
            <td colspan="${$targetRow.children('td').length}">
                <div class="cart-upsell">
                    <div class="cartUpsell">
    `;

        items.forEach(p => {

            const imgSrc = p.image
                ? p.image.replace('/orig/', '/detail/')
                : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';
            const hasDiscount = p.action_price && Number(p.action_price) < Number(p.price);
            html += `
            <div class="product" data-code="${p.code}" data-parent-sku="${targetSku}">

                <div class="p">
                    <span data-id="${p.code}" class="input"></span>
                    <div class="image">
                        <img src="${imgSrc}" alt="${p.name}">
                    </div>
                    <div class="p-in">
                        <div class="p-in-in">
                            
                                <span>${p.name}</span>
                            
                        </div>
                        <div class="p-bottom">
                            <div class="prices">
                                ${hasDiscount ? `
                                    <div class="price price-standard">
                                        <span class="price-before">
                                            ${Number(p.price).ShoptetFormatAsCurrency()}
                                        </span>
                                    </div>
                                    <div class="price price-standard">
                                        <strong>
                                            ${Number(p.action_price).ShoptetFormatAsCurrency()}
                                        </strong>
                                    </div>
                                ` : `
                                <div class="price price-final">
                                    <strong>${Number(p.price).ShoptetFormatAsCurrency()}</strong>
                                </div>
                                ` }

                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        });

        html += `
                    </div>
                </div>
            </td>
        </tr>
    `;

        $targetRow.after(html);
    }

    $('html').on('click', '.cartUpsell .product span.add-to-cart-button', function () {
        var thisCode = $(this).attr('data-id');
        shoptet.cartShared.addToCart({ productCode: thisCode, amount: 1 }, true);
    })

    function mhProductInfoMove() {


        $(function () {

            if (!$('.cart-table').length) return;

            const skus = [];

            $('.cart-table tr[data-micro="cartItem"]').each(function () {
                const sku = $(this).data('micro-sku');
                if (sku) skus.push(String(sku));
            });

            if (!skus.length) return;

            $.ajax({
                url: 'https://php.shopcode.cz/api/zahradnictvi-spomysl-Hu/api-cart.php',
                method: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ skus }),
                success: function (res) {
                    if (!res.upsellsBySku) return;

                    // pojistka – při AJAX reloadu
                    $('.cart-upsell-row').remove();

                    $('.cart-table tbody tr.removeable').each(function () {
                        const sku = $(this).data('micro-sku');

                        if (!sku) return;

                        const items = res.upsellsBySku[String(sku)] || res.upsellsBySku[Number(sku)];


                        if (items && items.length) {
                            renderUpsells(items, sku);
                            syncUpsellsWithCart();
                        }
                    });
                },


                error: function (xhr) {
                }
            })
        });






        $('.cart-table tr').each(function () {
            const $img = $(this).find('.cart-p-image img');
            const src = $img.attr('data-src') || $img.attr('src');
            if (src) {
                const newSrc = src.replace('/related/', '/detail/');
                $img.attr('data-src', newSrc);
                $img.attr('src', newSrc);
            }
            var findcenazakus = $(this).find('.p-price.p-cell').html();
            var findptotal = $(this).find('.p-total');
            $(this).find('.p-name').append('<div class="avail">' + $(this).find('.p-availability').html() + '</div>');
            $(findptotal).prepend('<span class="cenazaks">' + findcenazakus + '</span>');
        });
        if ($('.cart-table .p-discount').length) {
            $('.cart-table ').prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">${translation('cartProdukt')}</th>
                    <th class="avail">${translation('cartDostupnost')}</th>
                    <th class="qty">${translation('cartPocet')}</th>
                    <th class="unit">${translation('cartPcartCenaZaKusrodukt')}</th>
                    <th class="sale">${translation('cartsleva')}</th>
                    <th class="total">${translation('cartCelkem')}</th>
                </tr>
                    </thead>
            `);
        }
        else {
            $('.cart-table ').prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">${translation('cartProdukt')}</th>
                    <th class="avail">${translation('cartDostupnost')}</th>
                    <th class="qty">${translation('cartPocet')}</th>
                    <th class="unit">${translation('cartCenaZaKus')}</th>
                    <th class="total">${translation('cartCelkem')}</th>
                </tr>
                    </thead>
            `);
        }

        $('.sidebar-in-cart').prepend($('.cart-summary'));
        $('.cart-summary').append($('.summary-wrapper .next-step-back').clone());
        $('.summary-wrapper').after($('.summary-wrapper .next-step-back').clone());

        $('#continue-order-button span').text(translation('continueInOrder'));

        $('.cart-summary .extras-wrapper .extras-col:first').append(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                ${translation('darkovypoukaz')}
            </label>
        `);
        $('#discount-checkbox').on('change', function () {
            $('.discount-coupon').toggleClass('active', this.checked);
        });

    };
    mhProductInfoMove();
    initCartRelatedSlider();
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
        initCartRelatedSlider();

    });
}

$('html').on('click', '.cart-upsell-row .product', function (e) {
    e.preventDefault();

    const $product = $(this);
    const $flag = $product.find('span.input');
    const upsellCode = String($product.data('code'));
    const parentSku = String($product.data('parent-sku'));

    if (!upsellCode || !parentSku) return;

    const isActive = $flag.hasClass('yes');

    // =========================
    // ➕ PŘIDAT
    // =========================
    if (!isActive) {
        $flag.addClass('yes');
        saveUpsellBinding(parentSku, upsellCode);

        shoptet.cartShared.addToCart(
            { productCode: upsellCode, amount: 1 },
            true
        );
        return;
    }

    // ODEBRÁNÍ
    $flag.removeClass('yes');
    removeUpsellBinding(parentSku, upsellCode);
    decrementUpsellQuantity(upsellCode);
});


function decrementUpsellQuantity(upsellCode) {
    $('.cart-table tr[data-micro="cartItem"]').each(function () {
        const $row = $(this);
        const sku = String($row.data('micro-sku'));

        if (sku !== String(upsellCode)) return;

        const $input = $row.find('input[name="amount"]');
        const current = Number($input.val());

        if (current > 1) {
            $input.val(current - 1).trigger('change');
        } else {
            $row.find('button.remove-item').trigger('click');
        }
    });
}

function isUpsellAddedForParent(parentSku, upsellCode) {
    const store = JSON.parse(sessionStorage.getItem('cartUpsells') || '{}');
    return Array.isArray(store[parentSku]) &&
        store[parentSku].includes(upsellCode);
}


function syncUpsellsWithCart() {
    const cartItems = [];

    $('.cart-table tr[data-micro="cartItem"]').each(function () {
        cartItems.push({
            sku: String($(this).data('micro-sku')),
        });
    });

    $('.cart-upsell-row .product').each(function () {
        const $product = $(this);
        const upsellCode = String($product.data('code'));
        const parentSku = String($product.data('parent-sku'));
        const $flag = $product.find('span.input');

        if (!upsellCode || !parentSku) return;
        const isActive =
            cartItems.some(i => i.sku === parentSku) &&
            isUpsellAddedForParent(parentSku, upsellCode);

        $flag.toggleClass('yes', isActive);
    });
}

function saveUpsellBinding(parentSku, upsellCode) {
    const key = 'cartUpsells';
    const store = JSON.parse(sessionStorage.getItem(key) || '{}');

    if (!store[parentSku]) store[parentSku] = [];
    if (!store[parentSku].includes(upsellCode)) {
        store[parentSku].push(upsellCode);
    }

    sessionStorage.setItem(key, JSON.stringify(store));
}



function removeUpsellBinding(parentSku, upsellCode) {

    const key = 'cartUpsells';
    const store = JSON.parse(sessionStorage.getItem(key) || '{}');

    if (!store[parentSku]) return;

    store[parentSku] = store[parentSku].filter(c => c !== upsellCode);

    if (!store[parentSku].length) {
        delete store[parentSku];
    }

    sessionStorage.setItem(key, JSON.stringify(store));
}

function getUpsellQuantityInCart(upsellCode) {
    let qty = 0;

    $('.cart-table tr[data-micro="cartItem"]').each(function () {
        const $row = $(this);
        const sku = String($row.data('micro-sku'));

        if (sku === String(upsellCode)) {
            qty = Number($row.find('input[name="amount"]').val()) || 0;
        }
    });

    return qty;
}

function syncUpsellYesByQuantity(upsellCode) {
    const qtyInCart = getUpsellQuantityInCart(upsellCode);

    let remaining = qtyInCart;

    $('.cart-upsell-row .product[data-code="' + upsellCode + '"]').each(function () {
        const $product = $(this);
        const $flag = $product.find('.input');
        const parentSku = String($product.data('parent-sku'));

        if ($flag.hasClass('yes')) {
            if (remaining > 0) {
                remaining--;
            } else {
                // ❌ PŘEBYTEK → odstranit
                $flag.removeClass('yes');
                removeUpsellBinding(parentSku, upsellCode);
            }
        }
    });
}


$('html').on('change', '.cart-table input[name="amount"]', function () {
    const $row = $(this).closest('tr[data-micro="cartItem"]');
    const upsellCode = String($row.data('micro-sku'));

    if (!upsellCode) return;

    // jen pokud je to upsell produkt
    if ($('.cart-upsell-row .product[data-code="' + upsellCode + '"]').length) {
        syncUpsellYesByQuantity(upsellCode);
    }
});

$('html').on('click', '.cart-table .increase, .cart-table .decrease', function () {
    const $row = $(this).closest('tr[data-micro="cartItem"]');
    const upsellCode = String($row.data('micro-sku'));

    if (!upsellCode) return;

    if ($('.cart-upsell-row .product[data-code="' + upsellCode + '"]').length) {
        // počkáme až Shoptet přepíše input
        setTimeout(() => {
            syncUpsellYesByQuantity(upsellCode);
        }, 50);
    }
});


$('html').on('click', '.cart-table button.remove-item', function () {
    const $row = $(this).closest('tr[data-micro="cartItem"]');
    const upsellCode = String($row.data('micro-sku'));

    if (!upsellCode) return;

    // pokud existují upsell checkboxy
    if ($('.cart-upsell-row .product[data-code="' + upsellCode + '"]').length) {

        // 1️⃣ odškrtni všechny yes
        $('.cart-upsell-row .product[data-code="' + upsellCode + '"] .input')
            .removeClass('yes');

        // 2️⃣ smaž vazby ze storage
        const store = JSON.parse(sessionStorage.getItem('cartUpsells') || '{}');
        Object.keys(store).forEach(parent => {
            store[parent] = store[parent].filter(c => c !== upsellCode);
            if (!store[parent].length) delete store[parent];
        });
        sessionStorage.setItem('cartUpsells', JSON.stringify(store));
    }
});


function initCartRelatedSlider() {
    /* $('.cart-table tr.removeable').each(function () {
         var $productRow = $(this);
         var $relatedRow = $productRow.next('.related');
 
         if (!$relatedRow.length) return;
 
         var $products = $relatedRow.find('.cart-related-product');
         if (!$products.length) return;
 
         // vytvoření nového řádku
         var $newRow = $('<tr class="cart-related-row"></tr>');
         var $newCell = $('<td colspan="'+$relatedRow.find('td').attr('colspan')+'"></td>');
         var $slider = $('<div class="cartRelatedSlider"></div>');
 
         $products.each(function () {
             var $item = $(this);
 
             // ⚠️ klon + vlastní struktura
             var $slide = $(`
                 <div class="cartRelatedItem">
                     <a href="${$item.find('a.cart-related-img').attr('href')}" class="img">
                         ${$item.find('img')[0].outerHTML}
                     </a>
                     <a href="${$item.find('.cart-related-name').attr('href')}" class="name">
                         ${$item.find('.cart-related-name').text()}
                     </a>
                     <div class="price">
                         ${$item.find('.price-final').html()}
                     </div>
                 </div>
             `);
 
             $slider.append($slide);
         });
 
         $newCell.append($slider);
    
 
         // vložení hned za produkt
         $productRow.append($newCell);
 
         // původní related schováme
         $relatedRow.hide();
     });
 */
    // slick init
    /* $('.cartRelatedSlider').slick({
         slidesToShow: 4,
         slidesToScroll: 1,
         centerMode: false,
         autoplay: false,
         autoplaySpeed: 5000,
         dots: true,
         arrows: true,
         infinite: false,
         adaptiveHeight: false,
         responsive: [
         { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
         { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
         { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
         { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
         ]
     });*/
}
